import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=3604ea01&"
import script from "./CategorySlider.vue?vue&type=script&lang=js&"
export * from "./CategorySlider.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports